module.exports = function () {
   return {
       event: 'BWSAUguestCreated',
       eventContext: {
           area: 'Checkout - Step 1',
           fullfillmentType: 'Delivery/Click and collect'
       }
   };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/atmmapper/guest-user-created-mapper.js
 **/